import { PageBack } from "components/PageBack";
import "./index.scss";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "routes/config";

export function ComingSoon() {
  const navigate = useNavigate();
  return (
    <div className="coming-soon-container">
      <div className="flex justify-start w-full">
        <PageBack onBack={() => navigate(ROUTES.play)} />
      </div>
      <div className="flex flex-1 flex-col justify-center items-center">
        <h1 className="text-white text-[64px] text-center font-semibold">
          Coming soon....
        </h1>
      </div>
    </div>
  );
}
